import { CheckIcon, CodeIcon } from '@heroicons/react/outline';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { DataSourceIDEnum, DataSourceType, DataSourceTypeCodeConfig, EDataSourceCategory } from '../../../../models/dataSource';
import CodeRequiredIcon from "../../../../assets/icons/code_required.svg?react";
import NoCodeRequiredIcon from "../../../../assets/icons/no_code_required.svg?react";
import BestUsedForIcon from "../../../../assets/icons/best_used_for.svg?react";
import RequirementsIcon from "../../../../assets/icons/requirements.svg?react";

interface IDataSourceTypePanelContentProps {
  dataSourceType?: DataSourceType;
}

const DataSourceTypePanelContentV2: FunctionComponent<IDataSourceTypePanelContentProps> = ({ dataSourceType }) => {
  const { t } = useTranslation('data_sources');

  const id = dataSourceType.id as DataSourceIDEnum;
  const configuration = dataSourceType?.configuration as DataSourceTypeCodeConfig | undefined;

  return (
    <div className='flex flex-col gap-5'>
      <div className='flex flex-col gap-2'>
        <>
          {configuration?.website && (
            <div className='inline-block mr-5'>
              <a href={configuration.website} className='inline-block underline text-brand-600 text-sm'>
                {t('slideover.content.visit_website')}
              </a>
            </div>
          )}
          {dataSourceType?.category === EDataSourceCategory.CODE ? (
            <div className='inline-block'>
              <CodeRequiredIcon className='inline-block h-6 w-6 mr-3' />
              <p className='inline-block text-brand-600 text-base font-semibold'>{t('slideover.content.code_required')}</p>
            </div>
          ) : (
            <div className='inline-block'>
              <NoCodeRequiredIcon className='inline-block h-6 w-6 mr-3' />
              <p className='inline-block text-brand-600 text-base font-semibold'>{t('slideover.content.no_code_required')}</p>
            </div>
          )}
        </>
        <p className='text-gray-950 text-sm text-pretty'>{t(`catalog.${id}.description`)}</p>
      </div>
      
      
      <div className='flex flex-col gap-2'>
        <div className='inline-block'>
          <BestUsedForIcon className='inline-block h-6 w-6 mr-3' />
          <p className='inline-block text-brand-600 text-base font-semibold'>{t('slideover.content.best_used_for')}</p>
        </div>
        <div>
          <ul className='list-disc list-outside pl-[26px]'>
            {t(`catalog.${id}.usedFor`)?.map((use) => (
              <li key={use} className='text-gray-950 text-sm text-pretty'>
                {use}
              </li>
            ))}
          </ul>
        </div>
      </div>
      
      <div className='flex flex-col gap-2'>
        <div className='inline-block'>
          <RequirementsIcon className='inline-block h-6 w-6 mr-3' />
          <p className='inline-block text-brand-600 text-base font-semibold'>{t('slideover.content.user_need')}</p>
        </div>
        <div>
          <ul className='list-disc list-outside pl-[26px]'>
            {t(`catalog.${id}.requirements`)?.map((requirement) => (
              <li key={requirement} className='text-gray-950 text-sm text-pretty'>
                {requirement}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default DataSourceTypePanelContentV2;